import { RouterProvider } from "react-router-dom";
import { router } from "lib/routes";
import { ChakraProvider } from '@chakra-ui/react'
import { PageProvider } from "contexts/TimerAppContexts/PageContext";


function App() {
  return (
    <ChakraProvider>
      <PageProvider>
        <RouterProvider router={router} />
      </PageProvider>
    </ChakraProvider>
  );
}

export default App;
